import {createSlice} from "@reduxjs/toolkit";

import { useSelector } from 'react-redux'

const tourSlice = createSlice({
    name: 'tour',
    initialState: {
        steps: [],
        run: false,
        url: null,
        show_getting_started: false
    },
    reducers: {
        setTourSteps: (state, action) => {
            state.steps = action.payload.steps.map(step => {
                step.placement = step.placement ? step.placement : 'auto';
                if(step.clickToContinue === true) {
                    step.canBeClosed = false;
                    step.spotlightClicks = true;
                    step.hideFooter = true;
                }

                if(step.canBeClosed === false) {
                    step.disableCloseOnEsc = true;
                    step.disableOverlayClose = true;
                    step.hideCloseButton = true;
                }

                if(step.hideFooter) {
                    const stepStyles = step.styles ? step.styles : {};
                    step.styles = {
                        ...stepStyles,
                        buttonNext: {
                            display: 'none',
                        }
                    }
                }
                
                return {
                    ...step,
                    disableBeacon: true
                }
            });
            state.url = action.payload.url;
            state.run = true;
        },
        setTourIndex: (state, action) => {
            state.index = action.payload;
        },
        setTourRunState: (state, action) => {
            state.run = action.payload;
        },
        getTour: (state, action) => {
            return state;
        },
        reset: (state, action) => {
            state.steps = [];
            state.run = false;
            state.url = null;
        },

        setGettingStartedState(state, action) {
            state.show_getting_started = action.payload;
        } 
    }
});

export const tourActions = tourSlice.actions;

export const setTourSteps = (steps, url) => {
    return async (dispatch) => {
        dispatch(tourActions.setTourSteps({
            steps: [...steps].map((s) => {
                return {...s}
            }),
            url: url
        }))
    }
}

export const resetTour = () => {
    return async (dispatch) => {
        dispatch(tourActions.reset())
    }
}

export const getTour = () => {
    return async (dispatch) => {
        return dispatch(tourActions.getTour())
    }
}

export const setTourIndex = (index) => {
    return async (dispatch) => {
        dispatch(tourActions.setTourIndex(index))
    }
}

export const setTourRunState = (state) => {
    return async (dispatch) => {
        dispatch(tourActions.setTourRunState(state))
    }
}

export function useTour() {
    return useSelector((state) => state)
}


export const setGettingStartedState = (show) => {
    return async (dispatch, getState) => {
        dispatch(tourActions.setGettingStartedState(show))
    }
}

export default tourSlice.reducer;
